<template>
  <div class="hover-qrcode" :class="{hover:!noCode}">
    <slot />
    <div class="hover-qrcode-main" :class="{bottom:position==='bottom'}">
      <div class="hover-qrcode-main-inner">
        <div v-if="topText" class="hover-qrcode-top-text h5">{{ topText }}</div>
        <img :src="src" class="hover-qrcode-code" />
        <div v-if="text" class="hover-qrcode-text h5">{{ text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
//["src", "text", "topText", "position"]
export default {
  name: "HoverQrcode",
  props: {
    src: String,
    text: String,
    topText: String,
    position: String,
    noCode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@style/base";
.hover-qrcode {
  position: relative;

}
@include setThemeClass {
  .hover-qrcode-main {
    display: none;
    visibility: hidden;
    opacity: 0;
    margin-bottom: 14px;
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    box-shadow: $boxShadow;
    transition: 260ms $easeOutCubic all;
    z-index: 100;
    &.bottom {
      top: 100%;
      bottom: auto;
      margin-bottom: 0;
      margin-top: 14px;
      &.hover-qrcode-main::after {
        bottom: auto;
        top: -5px;
        border-left: 4px solid transparent;
        border-top: 4px solid transparent;
        border-bottom: 6px solid getThemeVal(brandColorWhite);
        border-right: 6px solid getThemeVal(brandColorWhite);
      }
    }
  }
  .hover-qrcode-main-inner {
    position: relative;
    background-color: getThemeVal(brandColorWhite);
    padding: 10px;
    z-index: 2;
    border-radius: 4px;
    .hover-qrcode-code {
      margin: 0 auto;
      width: 120px;
      height: 120px;
      display: block;
    }
    .hover-qrcode-top-text {
      margin-bottom: 5px;
      text-align: center;
    }
    .hover-qrcode-text {
      margin-top: 5px;
      text-align: center;
    }
  }
  .hover-qrcode-main::after {
    content: "";
    position: absolute;
    left: 50%;
    margin-left: -6px;
    bottom: -5px;
    z-index: 1;
    border-right: 4px solid transparent;
    border-bottom: 4px solid transparent;
    border-top: 6px solid getThemeVal(brandColorWhite);
    border-left: 6px solid getThemeVal(brandColorWhite);
    box-shadow: $boxShadow;
    transform: rotate(-135deg);
  }
}
.hover-qrcode.hover:hover {
  .hover-qrcode-main {
    display: block;
    visibility: visible;
    opacity: 1;
  }
}

</style>
